import React from 'react';
import {connect} from 'react-redux';
import strings from 'utils/strings';

import AudioPlayer from 'components/AudioPlayer';
import audioNo from 'assets/sounds/no/3-01-Tulleord-Intro.mp3';
import audioNn from 'assets/sounds/nn/3 01 Tulleord Intro.m4a';
import videoBiltoPil from './assets/video_byttelyd.mp4';
const languageObj = {
	no: audioNo,
	nn: audioNn,
};

class Intro extends React.Component {
	constructor(props) {
		super(props);
		this.audio = languageObj[strings.getLanguage()];
		this.video = videoBiltoPil;
		this.dragRef = React.createRef();
	}

	render() {
		const {onNextStep} = this.props;
		let videoRef;
		return (
			<div>
				<p>
					<AudioPlayer
					
						onStart={() => {
							videoRef.play();
						}}
						onErrorPlay={()=>{
							console.log('Something went wrong');
						}}
						onComplete={()=>{
							if (
																			this
																				.dragRef
																				.current
																		) {
																			this.dragRef.current.scrollIntoView(
																				{
																					behavior:
																						'smooth',
																					block: 'start',
																				}
																			);
																		}
						}}
						autoplay
						inline
						src={this.audio}
					/>
					{strings.formatString(
						strings.tulleordtesteneksempel1,
						<strong>b</strong>,
						<strong>bil</strong>,
						<strong>p</strong>,
						<strong>pil</strong>
					)}
				</p>
				<div className="lit-preview">
					<p className="lit-preview__label">{'Eksempel'}</p>
					<video
						className="lit-preview__video"
						loop
						ref={(ref) => {
							videoRef = ref;
						}}
						src={this.video}
					/>
				</div>
				<p>{strings.tulleordtestenPractice}</p>
				<button
					className="lit-btn bg-primary" ref={this.dragRef}
					onClick={() => {
						this.props.onShowAvatar(false);
						onNextStep();
					}}
				>
					{strings.toPractice}
				</button>
			</div>
		);
	}
}

const mapStateToProps = () => {
	return {};
};

export default connect(mapStateToProps)(Intro);
